/* eslint-disable array-callback-return */
import React, { useState, useEffect } from "react";
import {
  Collapse,
  Modal,
  ModalBody,
  ModalHeader,
  Col,
  Row,
  Input,
  Button,
} from "reactstrap";
import Select from "react-select";
//service
import { getLanguages } from "../../../utils/services/notification";

export default function ModalViewNotificationPrivate(props) {
  const { isOpen, toggle, data } = props;
  const [isOpenCollapse, setIsOpenCollapse] = useState(false);
  const [sendToParticipants, setSendToParticipants] = useState(true);
  // idiomas
  const [languages, setLanguages] = useState("");

  async function getAllLanguages() {
    await getLanguages().then((res) => {
      var idioms = data.multiIdiom
        ? data.sendToIdiom || data.notSendToIdiom
        : null;
      var idiomsString = "";

      if (idioms) {
        idiomsString = idioms
          .replaceAll("'", "")
          .split(",")
          .map((e) => {
            var getIdiom = res.data.find((obj) => obj.tag === e)?.name;

            if (getIdiom) {
              return getIdiom;
            }
          })
          .join(", ");
      }

      setLanguages(idiomsString);
    });
  }

  useEffect(() => {
    getAllLanguages();
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggleBackdrop();
      }}
      autoFocus={true}
      centered={true}
    >
      <ModalHeader toggle={toggle}>Visualizar Notificação</ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <Row>
            <Col lg={12}>
              <div>
                <label className="form-label">ID</label>
                <input
                  className="form-control"
                  type="text"
                  value={data.id}
                  disabled
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Título*</label>
                <input
                  className="form-control"
                  type="text"
                  value={data.title}
                  disabled
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Mensagem*</label>
                <textarea
                  className="form-control"
                  type="text"
                  value={data.text}
                  disabled
                />
              </div>
            </Col>
          </Row>

          <Row className="mt-3" style={{ cursor: "pointer" }}>
            <Col lg={12}>
              <i
                className="dripicons-gear"
                style={{
                  marginRight: 5,
                  marginTop: 2,
                  fontSize: 15,
                  fontWeight: "bold",
                }}
              />
              <span className="font-size-14">Personalização Avançada</span>
            </Col>
          </Row>

          {data.image && (
            <Row className="mt-1" style={{ paddingTop: 10 }}>
              <Col lg={12}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <a className="form-label" style={{ color: "black" }}>
                    Foto
                  </a>
                  <img style={{ width: 100, height: 100 }} src={data.image} />
                </div>
              </Col>
            </Row>
          )}

          <Row className="mt-2 mb-4">
            <Col lg={12}>
              <div>
                <label className="form-label">Tipo de Link</label>
                <input
                  className="form-control"
                  type="text"
                  value={data.linkLabel}
                  disabled
                />
              </div>
            </Col>
          </Row>

          {data.linkLabel === "Externo" && (
            <Row className="mt-2 mb-4">
              <Col lg={12}>
                <div>
                  <label className="form-label">Link</label>
                  <Input
                    className="form-control"
                    type="text"
                    value={data.link}
                    disabled
                  />
                </div>
              </Col>
            </Row>
          )}

          <hr className="border-1 border-top border-dark" />

          <Row>
            <h5 className="font-size-14 mt-1">Enviar push agora?</h5>
          </Row>

          <Row className="mt-1">
            <Col md={4}>
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios1"
                  value="option1"
                  checked={!data.schedule}
                  disabled
                />
                <label className="form-check-label" htmlFor="exampleRadios1">
                  Sim
                </label>
              </div>
              <div className="form-check mb-1">
                <input
                  className="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios2"
                  value="option2"
                  checked={data.schedule}
                  disabled
                />
                <label className="form-check-label" htmlFor="exampleRadios2">
                  Não
                </label>
              </div>
            </Col>
            {data.schedule && (
              <Col md={8}>
                <Row>
                  <Col md={6}>
                    <div>
                      <label className="form-label">Agendar para dia*</label>
                      <input
                        className="form-control"
                        type="date"
                        disabled
                        value={data.schedule ? data.date.split("T")[0] : ""}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div>
                      <label className="form-label">Hora*</label>
                      <input
                        className="form-control"
                        type="time"
                        value={data.schedule ? data.hour : ""}
                        disabled
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            )}
          </Row>

          <hr className="border-1 border-top border-dark" />

          <Row>
            <Col md={12}>
              <div className="form-check form-check-end mt-1">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={data.multiIdiom}
                  disabled
                />
                <label>O Push vai ser Multi-idiomas?</label>
              </div>
            </Col>
          </Row>

          {data.multiIdiom && (
            <Row>
              <Row style={{ marginTop: 20, marginBottom: 20 }}>
                <Col md={6}>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="langRadio"
                      id="participantRadios1"
                      value="opt1"
                      checked={data.multiIdiom && data.sendToIdiom}
                      disabled
                    />
                    <label
                      className="form-check-label"
                      htmlFor="participantRadios1"
                    >
                      Indicar idioma(s) que o push será enviado
                    </label>
                  </div>
                </Col>

                <Col>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="langRadio"
                      id="removeLangRadios2"
                      value="opt2"
                      checked={data.multiIdiom && data.notSendToIdiom}
                      disabled
                    />
                    <label
                      className="form-check-label"
                      htmlFor="removeLangRadios2"
                    >
                      Retirar idioma(s) do push
                    </label>
                  </div>
                </Col>
              </Row>

              <Col lg={12}>
                <div>
                  <label className="form-label">Escolha o idioma</label>
                  <input
                    className="form-control"
                    type="text"
                    value={data.multiIdiom && languages ? languages : ""}
                    disabled
                  />
                </div>
              </Col>
            </Row>
          )}

          <Row
            style={{
              width: "100%",
              margin: "auto",
              display: "flex",
              justifyContent: "flex-end",
              paddingTop: 10,
            }}
          >
            <Button
              color="success"
              className="btn btn-danger waves-effect waves-light"
              style={{ width: 80, marginRight: 5 }}
              onClick={() => toggle()}
            >
              Fechar
            </Button>
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
}
